<template>
  <a-card class="m-t-10" :bordered="false">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      调仓操作
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" >
      <a-form-item label="调仓单" name='transfer_warehousing_sn'>
        <span>{{form.transfer_warehousing_sn}}</span>
      </a-form-item>
      <a-form-item label="调仓仓库" name='transfer_to_warehouse_id' >
        <a-select v-model:value="form.transfer_to_warehouse_id" style='width: 380px' placeholder='请选择仓库' @change='selectChange' :disabled="isDisabled">
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="库位" name='transfer_to_warehouse_position_id'>
        <a-select v-model:value="form.transfer_to_warehouse_position_id" style='width: 380px;' placeholder='请选择库位' :disabled="!form.transfer_to_warehouse_id || isDisabled" >
          <a-select-option  :value="0">无</a-select-option>
          <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10' @click='form.transfer_to_warehouse_position_id = null' :disabled="!form.transfer_to_warehouse_id || isDisabled">清空</a-button>
      </a-form-item>
      <a-form-item label="扫码类型" name='scan_type'>
        <a-radio-group v-model:value="form.scan_type" @change='form.code = ""'>
          <a-radio :value="1">正常扫码</a-radio>
          <a-radio :value="2">回退扫码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="扫描二维码" name='code' >
        <a-input style="width: 480px;margin-right: 10px;" v-model:value="form.code" @pressEnter='scanCode' placeholder="请输入二维码"></a-input>
        <a-button class='m-r-10' type="primary" @click='scanCode' :loading='submitLoading'>添加</a-button>
        <a-tooltip placement='right'>
          <template #title>
            <p>1、点击“添加”后数据直接保存。如果使用扫描枪设备，不需要点击“添加”按钮，设备扫描完成会自动保存。</p>
            <p>2、使用扫描枪扫描时注意先将“光标”放到输入框中。（鼠标点一下输入框）</p>
            <p>3、程序自带提示音，会根据录入结果提示对应的声音，方便盲扫，请确保电脑带有声音播放功能。</p>
          </template>
          <InfoCircleOutlined class="fz-18" />
        </a-tooltip>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3}" v-if='showResult'>
        <div class="p-24 s_bf7">
          <p class="s_lin_h30 s_font_b">本次调仓数量计数</p>
          <p class="s_lin_h30">扫码数量：{{scanCodeNum}}</p>
          <p class="s_lin_h30">成功数量：{{successNum}}</p>
          <p class="s_lin_h30">成功商品数量：{{successGoodsNum}}</p>
        </div>
        <a-card class='m-t-10'>
          <p class="s_lin_h30">扫码结果：</p>
          <p class="s_lin_h30">
            <span v-if='form.scan_type == 1'>{{resultCode == 0 ? '调仓成功！':'调仓失败！'}}</span>
            <span v-else>{{resultCode == 0 ? '回退成功！':'回退失败！'}}</span>
          </p>
          <p class="s_lin_h30" v-if='resultCode != 0'>失败原因：</p>
          <p class="s_lin_h30" v-if='resultCode != 0'>{{resultMsg}}</p>
        </a-card>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3}">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">退出</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
  import { LeftOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  import { getWarehouseList,getTransferWarehousingSn,setFastTransferWarehousing, } from '@/api/antiFleeing';
  let defForm = {
    transfer_to_warehouse_position_id:0,
    scan_type:1,
    transfer_to_warehouse_id:1,
    code:'',
    transfer_warehousing_sn:'',
  };
  export default {
    components: { LeftOutlined,InfoCircleOutlined },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const validatePass = async (rule, value) => {
            if(state.rulesStatus){
               if(value==''){
                return Promise.reject('二维码不能为空');
                }
            }else{
                return Promise.resolve();
          }
      }
      const state = reactive({
        submitLoading:false,
        info: store.state.user.info,
        labelCol: {span: 3},
        wrapperCol: {span: 13},
        showCode:false, //是否显示调仓二维码
        showError:false, // 是否显示错误二维码列表
        isDisabled:false,// 扫码成功禁用一些选项
        selectListId:'',
        warehouseList:[], // 仓库列表
        warehouseChild:[], // 库位列表
        scanCodeNum:0, //扫码数量
        successNum:0, // 成功数量
        successGoodsNum:0, //成功商品数量
        showResult:false, // 是否显示扫码结果
        resultCode:'', //扫码结果code
        resultMsg:'', // 扫码结果提示语
        rulesStatus:true, // 调仓不校验二维码，添加时校验--胖子说的
        rules: {
          transfer_to_warehouse_id: [
            { required: true, message: '请选择发货仓库',type:'number'}
          ],
          scan_type:[
            { required: true,  message: '请选择扫码类型',type:'number'}
          ],
          code:[
            {
              validator: validatePass
            }
          ]
        },
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "调仓数量",
            dataIndex: "num",
            key: "num",
            slots: { customRender: "num" },
          },
          {
            title: "操作",
            key: "action",
            width:240,
            slots: { customRender: "action" }
          }
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
            // 默认选择默认仓库
          form.value.transfer_to_warehouse_id=res.data[0].id
          state.warehouseChild = res.data[0].child 
        } else {
          message.error(res.msg);
        }
      }
      //选择仓库
      const selectChange = () =>{
        form.value.transfer_to_warehouse_position_id = 0
        var item = state.warehouseList.find(v => v.id == form.value.transfer_to_warehouse_id)
        state.warehouseChild = item.child || []
      }
      // 生成调仓单号
      const outWarehousingSnGet = async () => {
        let res = await getTransferWarehousingSn().then(res => res.data);
        if (iscode(res)) {
          form.value.transfer_warehousing_sn = res.data.transfer_warehousing_sn;
        } else {
          message.error(res.msg);
        }
      }
      //扫码
      const scanCode = () => {
        state.rulesStatus = true;
        ruleForm.value.validate().then(async() => {
          const hide = message.loading("正在加载中...", 0);
          state.submitLoading = true;
          let res = await setFastTransferWarehousing({ ...form.value}).then((res) => res.data).catch(error => error);
          if (iscode(res)) {
            message.success(res.msg);
            state.scanCodeNum = state.scanCodeNum+1
            state.successNum = state.successNum+1
            state.successGoodsNum=res.data.num
            // if(form.value.scan_type==1){ //扫码
            //   state.successGoodsNum = state.successGoodsNum+res.data.num;
            // }else{ //回退
            //   state.successGoodsNum = state.successGoodsNum-res.data.num;
            // }
            state.isDisabled = true
          } else {
            message.error(res.msg);
          }
          state.resultCode = res.code
          state.resultMsg = res.msg
          state.showResult = true
          form.value.code = ''
          state.submitLoading = false;
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      };

      onMounted(() => {
        getWarehouse();
        outWarehousingSnGet();
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        scanCode,
        selectChange,
      };
    },
  };
</script>